<template>
  <div class="upload-cover-con clearfix">
    <yxtbiz-upload-image
      no-crop
      multipe
      :list='list'
      :limit='5'
      config-key="ImageConfigKey"
      module-name="test_module"
      source="501"
      :size="2048"
      function-name="test_function"
      :oversize-msg="$t('pc_biz_complain_oversize')"
      @fileAdded="fileAdded"
      @fileRemoved="fileRemoved"
      app-code="cc"
    ></yxtbiz-upload-image>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: []
    };
  },
  props: {
    logoUrl: {
      type: Array,
      default: []
    }
  },
  computed: {
    uploadList() {
      return this.list.map(item => item.url);
    }
  },
  methods: {
    fileAdded({ index, url }) {
      this.$set(this.list, index, { url });
      this.$emit('update:logoUrl', this.uploadList);
    },
    fileRemoved(index) {
      this.list.splice(index, 1);
      this.$emit('update:logoUrl', this.uploadList);
    }
  }
};
</script>
